import { render, staticRenderFns } from "./DropCard.vue?vue&type=template&id=56a33f20&scoped=true"
import script from "./DropCard.vue?vue&type=script&lang=js"
export * from "./DropCard.vue?vue&type=script&lang=js"
import style0 from "./DropCard.vue?vue&type=style&index=0&id=56a33f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a33f20",
  null
  
)

export default component.exports